import type { HeartbeatResponse } from '@/protocol/OcppAdapter';

export function buildHeartbeatRequest(): Record<string, never> {
  return {};
}

export function parseHeartbeatResponse(payload: Record<string, unknown>): HeartbeatResponse {
  return { currentTime: payload['currentTime'] as string };
}
